// @ts-nocheck
import * as React from "react";
import { Props, ISelect, State } from "./types";
// @ts-ignore
import ICON_VALIDATE from "../../assets/icon-validate.svg";
// @ts-ignore
import ICON_CLOSE from "../../assets/plus-svg.svg";
// @ts-ignore
import ICON_CARET from "../../assets/caret.svg";
// @ts-ignore
import ICON_SEARCH from "../../assets/icon-search.svg";
import ReactTooltip from 'react-tooltip'
import classnames from "classnames";

import "./styles.scss";

export class SelectV2 extends React.Component<Props, State> {
  refElement: any;
  timer: number

  constructor(props: Props) {
    super(props);

    this.state = {
      numberSelectedItems: 0,
      elements: [],
      onFocus: false,
      isOpenDropdown: false,
      data: props.data || [],
      valueInput:
        (Array.isArray(props.initialValues) &&
          props.initialValues &&
          props.initialValues[0] &&
          props.initialValues[0].value[0]) ||
        "",
    };
    this.refElement = React.createRef();
  }

  /**
  * @name componentDidMount
  * @description React Lifecycle
  * @author (Set the text for this tag by adding docthis.authorName to your settings file.)
  * @memberof SelectV2
  */
  componentDidMount() {
    document.addEventListener("mousedown", this.hideDropdownByRef);

    let state = {};

    if (typeof this.props.initialValues === "string") {
      state = {
        ...state,
        valueInput: this.props.initialValues,
      };
    } else {
      state = {
        ...state,
        elements: this.props?.initialValues ? this.props.initialValues : null,
      };
    }

    if (this.props.action) {
      this.props.action();
    }

    this.setState(state)
  }

  /**
  * @name componentDidUpdate
  * @description React Lifecycle
  * @author Jonathan IBOR
  * @param {Props} nextProps
  * @param {State} nextState
  * @memberof SelectV2
  */
  async componentDidUpdate(nextProps: Props, nextState: State) {
    const { elements } = this.state;

    if (this.state.elements !== nextState.elements) {
      if (typeof elements === "string") {
        this.setState({ valueInput: elements });
      }
    }

    if (this.props.multi) {
      /* if (this.state.elements?.length !== nextState.elements?.length) {
        console.log('get element 1', this.state.elements)
        // this.props.getElements(this.state.elements);
      } */

      /* if (Array.isArray(this.props.initialValues)) {
        this.props.initialValues?.forEach((item, index) => {
          if (
            this.props.initialValues &&
            this.props.initialValues[index]?.value !==
              (nextProps.initialValues &&
                nextProps.initialValues[index]?.value)
          ) {
            this.setState({
              // elements: this.props.initialValues || [],
            });
          }
        });
      } */
    }

    if (!this.props.multi) {
      /* if (this.state.elements?.value !== nextState.elements?.value) {
        console.log("get element 2", this.state.elements);
        // this.props.getElements(this.state.elements);
      } */

      if (this.props.type === "text") {
        if (this.state.valueInput !== nextState.valueInput) {
          this.props.getElements(this.state.valueInput);
        }
      }

      if (
        this.props.initialValues?.value !==
        nextProps.initialValues?.value
      ) {
        this.setState({
          elements: this.props.initialValues || [],
        });
      }
    }

    if (this.props.initialValues !== nextProps.initialValues) {
      if (typeof this.props.initialValues === "string") {
        this.setState({ valueInput: this.props.initialValues });
      }
    }

    /* if (
      this.props.initialValues?.length !==
      nextProps.initialValues?.length
    ) {
      this.setState({ elements: this.props.initialValues });
    } */

    if (this.props.isAutoComplete) {

      if (this.state.valueInput !== nextState.valueInput) {
        if (this.props.action) {
          clearTimeout(this.timer)

          this.timer = setTimeout(() => {
            this.props.action({ name: this.state.valueInput });
          }, 500)
        }
      }

      if (this.props?.data !== nextProps?.data) {
        this.setState({ data: this.props?.data || [] });
      }
    }
  }

  /**
  * @description
  * @memberof SelectV2
  */
  hideDropdownByRef = (event: Event) => {
    const { type } = this.props;

    if (type !== "text") {
      if (
        this.refElement &&
        !this.refElement?.current?.contains(event?.target)
      ) {
        this.setState({ valueInput: "", isOpenDropdown: false, onFocus: false });
      }
    }
  };

  /**
  * @description
  * @memberof SelectV2
  */
  onClickElement = (_: Event, currentValue: ISelect) => {
    let state = {
      elements: [],
      valueInput: "",
    }

    if (this.props.multi) {
      state = {
        ...state,
        elements: [...this.state.elements, currentValue],
      }
    } else {
      state = {
        ...state,
        elements: currentValue,
      }
    }

    const isEqualToCurrentValue =
      !this.props.secondary &&
      this.state.elements.some(
        (item) => item.value === currentValue.value
      );

    if (isEqualToCurrentValue) {
      state = {
        ...state,
        elements: this.state.elements.filter(
          (item) => item.value !== currentValue.value
        ),
      };
    }

    this.setState(state);
    this.props.getElements(state.elements);
  };

  /**
  * @name onHandleResetFilter
  * @description
  * @author Jonathan IBOR
  * @memberof SelectV2
  */
  onHandleResetFilter = (e) => {
    e.stopPropagation();
    this.setState({
      elements: [],
      valueInput: "",
      isOpenDropdown: false,
    });

    if (this.props.onHandleReset) {
      this.props.onHandleReset();
    }
  };

  /**
  * @name onHandleToggleDropdown
  * @description
  * @author Jonathan IBOR
  * @memberof SelectV2
  */
  onHandleToggleDropdown = (e) => {
    e.stopPropagation();
    if (!this.props.secondary) {
      return this.setState({ isOpenDropdown: true });
    }

    return this.setState({ isOpenDropdown: !this.state.isOpenDropdown });
  };

  renderItemDropdown = (el: ISelect, index: number, exist: boolean) => {
    const { multi } = this.props;

    return (
      <div
        key={`${el.label}__${index}`}
        className={`selectV2__item ${
          exist ? "selectV2__item__active" : ""
        }`}
        onClick={(event: any) => this.onClickElement(event, el, index)}
        data-value={el.value}
      >
        {multi && (
          <>
            <div
              className="selectV2__checkbox"
              style={exist ? { background: "black" } : {}}
            >
              <ICON_VALIDATE />
            </div>
          </>
        )}

        <p data-tip={el.label} style={{ pointerEvents: "none" }}>
          {el.label}
        </p>
      </div>
    );
  };

  renderOptions = () => {
    const {
      children,
      openChildren,
      secondary,
    } = this.props;
    const { isOpenDropdown, data } = this.state;

    if (isOpenDropdown && Array.isArray(data)) {
      return (
        <div style={{ position: "relative", zIndex: 10, width: "100%" }}>
          <div className="selectV2__items" style={{ minWidth: "200px", left: !secondary ? '-10px' : '-20px', width: '100%' }}>
            {data.map((el, index) => {
              const exist = this.props.multi
                ? this.state.elements.some(
                    (item) => item?.value == el?.value
                  )
                : el?.value === this.state.elements?.value;

              if (
                el.label &&
                (el.label
                  .toLowerCase()
                  .includes(this.state.valueInput.toLowerCase()) ||
                  this.state.valueInput.includes(el?.value))
              ) {
                return (
                  <div
                    data-tip
                    data-for={`tooltipSelect_${el?.value}`}
                    key={index}
                  >
                    {this.renderItemDropdown(el, index, exist)}
                    <ReactTooltip
                      id={`tooltipSelect_${el?.value}`}
                      place="bottom"
                      effect="solid"
                    >
                      {el.label}
                    </ReactTooltip>
                  </div>
                );
              }

              return null;
            })}
          </div>
        </div>
      );
    }

    if (openChildren && children) {
      return children;
    }

    return null;
  };

  renderInitialValues = () => {
    const { elements } = this.state;
    const { secondary } = this.props;

    if (Array.isArray(elements) && this.state.valueInput === "") {
      return elements?.map(
        (el, index) =>
          index <= 1 && (
            <div
              key={index}
              className="selectV2__value"
              style={secondary ? { textAlign: "center", zIndex: 2 } : {}}
            >
              <span>
                {elements && elements.length === 1
                  ? el?.label
                  : `${el?.label},`}
              </span>
            </div>
          )
      );
    }

    return (
      <div
        className="selectV2__value"
        style={
          secondary
            ? { textAlign: "center", zIndex: 2 }
            : {}
        }
      >
        {elements?.label}
      </div>
    );
  };

  inputStyle = (isSecondaryWithElement: boolean) => {
    if (isSecondaryWithElement) {}
  };

  render() {
    const {
      label,
      type,
      className,
      isSelected,
      multi,
      secondary,
      isAutoComplete,
    } = this.props;

    const { elements } = this.state;

    const lengthElements = elements && (elements?.length || Object.entries(elements)?.length) || 0;
    const isSecondaryWithElement = secondary && lengthElements > 0;
    const value = this.state?.elements?.label || this.state.valueInput;

    const INPUT_STYLE = {
      padding: "0px",
      width: this.props.type === 'text' ? "110px" : 'auto',
      padding: this.props.type !== 'text' && secondary ? '1rem 2rem 1rem 2.5rem' : ''
    }

    if (isSecondaryWithElement && this.props.type !== "text") {
      INPUT_STYLE.background = "#656A75"
    }
    
    return (
      <div
        className={classnames(
          "selectV2",
          secondary && "selectV2__secondary",
          className && className
        )}
        ref={this.refElement}
      >
        <div className="selectV2__label">
          <p>
            <span style={{ marginRight: "5px" }}>{label}</span>
            {multi && (
              <span className="counterSelectedItems">
                {lengthElements === 0 ? "" : `(${this.state.elements.length})`}
              </span>
            )}
          </p>
        </div>
        <div
          className={classnames(
            elements &&
              elements.length !== 0 &&
              !secondary &&
              "selectV2__focus",
            this.state.isOpenDropdown &&
              !secondary &&
              this.state.onFocus &&
              "selectV2__focus",
            this.props.type === "text" &&
              this.state.valueInput.length !== 0 &&
              "selectV2__focus",
            this.props.type === "text" &&
              this.state.onFocus &&
              "selectV2__focus",
            "selectV2__container"
          )}
          onClick={this.onHandleToggleDropdown}
          style={INPUT_STYLE}
          onBlur={() => {
            this.setState({ onFocus: false });
          }}
          onFocus={() => {
            this.setState({ onFocus: true });
          }}
        >
          <div className="selectV2__row">
            <input
              type={type}
              readOnly={!isAutoComplete}
              style={{
                display: isAutoComplete ? "block" : "none",
                paddingLeft: type === "text" && secondary ? "15px" : "inherit",
              }}
              className={classnames(
                "selectV2__input",
                isSecondaryWithElement && "selectV2__input__secondary",
                isSelected && "selectV2__input__selected"
              )}
              placeholder={lengthElements > 0 ? "" : this.props.placeholder}
              onChange={(event: any) =>
                this.setState({
                  valueInput: event.target.value,
                })
              }
              value={this.state.valueInput}
            />

            {!isSecondaryWithElement && !isAutoComplete && (
              <span style={{ fontSize: "11px", color: "#1F2534" }}>
                {this.props.placeholder}
              </span>
            )}

            {lengthElements === 0 && type !== "text" && (
              <div
                className="selectV2__icon selectV2__icon--caret"
                style={{
                  top: "50% !important",
                  right: "45px !important",
                }}
              >
                <ICON_CARET />
              </div>
            )}
          </div>
          {!this.props.isReset && (
            <div
              style={{
                position: "absolute",
                minWidth: "95px",
                visibility: "hidden",
                fontSize: "11px",
                marginTop: `${value || this.props.placeholder ? "-14px" : 0}`,
                zIndex: 0,
              }}
            >
              {value.length > 0 ? value : this.props.placeholder}
            </div>
          )}

          {secondary && type === "text" && (
            <div className="selectV2__icon--search">
              <ICON_SEARCH />
            </div>
          )}

          {this.state.valueInput === "" && (
            <div
              className="selectV2__values"
              style={{
                position: !secondary ? "absolute" : "relative",
                paddingLeft: !secondary ? "10px" : "inherit",
                paddingRight: !secondary ? "10px" : "inherit",
                left: !secondary ? 0 : "inherit",
                boxSizing: "border-box",
                justifyContent: !secondary ? "space-between" : "center",
              }}
            >
              {this.renderInitialValues()}

              {type !== "text" && lengthElements > 0 && (
                <div
                  className="selectV2__icon selectV2__icon--close"
                  onClick={(e) => this.onHandleResetFilter(e)}
                  style={
                    isSecondaryWithElement
                      ? {
                          background: "#656A75",
                          marginLeft: "10px",
                        }
                      : { marginLeft: "10px" }
                  }
                >
                  <ICON_CLOSE />
                </div>
              )}
            </div>
          )}

          <div style={{ width: "100%" }}>{this.renderOptions()}</div>
        </div>
      </div>
    );
  }
}
